import { rest } from "msw";
import { mockInboundSearchConfirm, mockOrderInboundProduct, } from "./inbound.mocks";
const inboundRequestHandlers = [
    // 발주 입고 시 발주 제품 조회
    rest.get("/inbound-confirm/commercial/purchase", (_, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockOrderInboundProduct));
    }),
    // 입고 신청
    rest.post("/inbound-confirm/commercial", (_, res, ctx) => {
        return res(ctx.status(200), ctx.json({ message: "입고 신청 완료" }));
    }),
    rest.post("/inbound-confirm/research", (_, res, ctx) => {
        return res(ctx.status(200), ctx.json({ message: "입고 신청 완료" }));
    }),
];
const inboundConfirmHandlers = [
    // 입고 현황 조회
    rest.get("/inbound-confirm/commercial", (_, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockInboundSearchConfirm));
    }),
    rest.get("/inbound-confirm/research", (_, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockInboundSearchConfirm));
    }),
];
export const inboundHandlers = [
    ...inboundRequestHandlers,
    ...inboundConfirmHandlers,
];
